<template>
  <div class="modal-mask" v-show="showCategoryModal" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">Категория</slot>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label>Наименование [RU]</label>
            <input type="text" class="form-control" v-model="category.ru_title" @change="checkCategoryNameExist()"/>
            <span class="text-danger text-sm" v-if="categoryNameExist">Наименование существует</span>
          </div>
          <div class="form-group">
            <label>Код [Если пустой подставится порядковый ID]</label>
            <input type="text" class="form-control" v-model="category.code"/>
          </div>
          <div class="form-group">
            <label>Категория</label>
            <select class="form-control" v-model="category.parent_id">
              <option :selected="category.parent_id === 0 || category.parent_id === undefined" value="0">
                Основная Категория
              </option>
              <option :selected="category.parent_id !== 0" :value="category.parent_id">Выбранная категория
              </option>
            </select>
          </div>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <button class="modal-button btn btn-danger" @click="updateTab('update',false)">Закрыть</button>
            <button class="modal-button btn btn-success" @click="categoryStore()">Добавить</button>
          </slot>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {GET, POST} from "@/shared/api";

export default {
  props: {
    category: {},
    showCategoryModal: false,
    languages: []
  },
  data() {
    return {
      categoryNameExist: false,
      categorySearchData: [],
    }
  },
  methods: {

    updateTab(event, state) {
      this.$emit(event, state);
    },
    categoryStore() {
      POST(this.category, "/category", this).then(response => {
        this.updateTab('update', {created: true});
      });
    },

    checkCategoryNameExist() {
      GET([], "/checkCategoryNameExist/" + this.category.ru_title, this, false).then(response => {
        if (response != null) {
          this.categoryNameExist = true
        } else {
          this.categoryNameExist = false
        }
      })
    },
  }
}
</script>

<style scoped>

</style>